export const GRAZE_DEFINITION_ID = 'weapon-mastery:graze';

const masteryKey = (attack) => String(
  attack?.mastery?.key || attack?.mastery?.id || attack?.mastery?.label || ''
).trim().toLowerCase();

export const getGrazeDamage = (attack) => Math.max(0, Number(attack?.abilityModifier) || 0);

export const qualifiesForGraze = ({ attack, outcome }) => Boolean(
  attack?.kind === 'weapon' && attack?.hasWeaponMastery && masteryKey(attack) === 'graze' &&
  outcome === 'miss' && getGrazeDamage(attack) > 0
);

export const createGrazeDecision = ({ resolutionId, damage, damageType }) => ({
  id: `${resolutionId}:${GRAZE_DEFINITION_ID}`,
  kind: 'use-feature',
  featureId: GRAZE_DEFINITION_ID,
  resolutionId,
  title: 'Weapon Mastery: Graze',
  label: 'Weapon Mastery: Graze',
  prompt: `Use Graze to deal ${damage}${damageType ? ` ${damageType}` : ''} damage?`,
  choices: [{ id: 'apply', label: 'Graze' }, { id: 'skip', label: 'Skip' }],
});

/** The built-in miss-feature evaluator. Additional miss effects can join this list. */
export const evaluateWeaponMasteryMissFeatures = ({ attack, outcome, resolutionId }) => {
  if (!qualifiesForGraze({ attack, outcome })) return [];
  const damage = getGrazeDamage(attack);
  return [{
    featureId: GRAZE_DEFINITION_ID,
    status: 'confirmation-required',
    fixedDamage: damage,
    damageType: attack.damageType || '',
    decision: createGrazeDecision({ resolutionId, damage, damageType: attack.damageType }),
  }];
};
